
//action types
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const GET_DASHBOARD_API_CALLS_ADMIN = "GET_DASHBOARD_API_CALLS_ADMIN";
export const GET_API_VALIDITY_ADMIN = "GET_API_VALIDITY_USER_ADMIN";
export const GET_API_VALIDITY_ADMIN_SECOND = "GET_API_VALIDITY_USER_ADMIN_SECOND";
export const GET_API_LOG = "GET_API_LOG";

//upload image
export function getDashboard(data, callback) {
  return {
    type: GET_DASHBOARD,
    payload: { data, callback },
  };
}
export function getDashboardApiCallsAdmin(data, callback) {
  return {
    type: GET_DASHBOARD_API_CALLS_ADMIN,
    payload: { data, callback },
  };
}
export function getAdminValidityApiAdmin(data, callback) {
  return {
    type: GET_API_VALIDITY_ADMIN,
    payload: { data, callback },
  };
}
export function getAdminValidityApiAdminSecond(data, callback) {
  return {
    type: GET_API_VALIDITY_ADMIN_SECOND,
    payload: { data, callback },
  };
}
export function getAdminLogData(data, callback) {
  return {
    type: GET_API_LOG,
    payload: { data, callback },
  };
}
